import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getData } from "../../services/generalService";
import { AccountCardsObj } from "../../utils/types";

const initialState: AccountCardsObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getAccountCardsData = createAsyncThunk(
  "loans/getAccountCardsDetails",
  async (url: string, thunkAPI) => {
    try {
      const data = await getData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const accountCardsSlice = createSlice({
  name: "accountsCards",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAccountCardsData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAccountCardsData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getAccountCardsData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default accountCardsSlice.reducer;
